
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all-category",
      function () {
        return require("private-next-pages/all-category.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all-category"])
      });
    }
  